<div class="menu-component">
  @if (!collapsed) {
    <div class="backdrop" (click)="toggleMenu()"></div>
  }
  <div class="navbar-inverse side-collapse menu-mobile" [ngClass]="!collapsed ? 'menu-open' : ''">
    <nav role="navigation" class="navbar navbar-expand-md navbar-collapse">
      <ul class="nav navbar-nav main-menu w-100">
        <li class="no-padding-left fw-bold title-menu">
          <button class="picto-close" style="z-index: 99999" (click)="toggleMenu()">
            <img src="assets-front/pictos/picto-croix.svg" class="picto-close-menu">
          </button>
        </li>
        @if (logements$ | async; as logements) {
          @if (logements?.length) {
            <li  class="nav-item dropdown">
              <a class="picto-home dropdown-toggle" id="dropdownLogement" (click)="toggleMenuChilds('logement')" ><span>Mon logement</span></a>
              <div aria-labelledby="dropdownLogement" class="mb-3" [class.d-none]="!toggleMenuItems.logement">
                <a (click)="toggleMenu()" routerLink="/mes-logements/modifier/{{logementCourantId}}" data-intro="logement" class="ps-3 pt-2 pb-2">Infos principales</a>
                <a (click)="toggleMenu()" routerLink="/mon-logement"  data-intro="logement" class="ps-3 pt-2 pb-2">Caractéristiques</a>
                <a (click)="toggleMenu()" routerLink="/documents" data-intro="documents" class="ps-3 pt-2 pb-2"><span>Documents</span></a>
              </div>
            </li>
            @if (isSonergiaPartner((logementCourant$ | async))) {
              <li><a (click)="toggleMenu()" routerLink="/travaux" class="picto-travaux-renovation" data-intro="travaux"><span>Parcours travaux</span></a></li>
            }
            @if (isParcoursTravauxEnabled() && !isSonergiaPartner((logementCourant$ | async))) {
              <li><a (click)="toggleMenu()" routerLink="/parcours-travaux" class="picto-travaux-renovation" data-intro="travaux"><span>Projet travaux</span></a></li>
            }
            <li  class="nav-item dropdown" >
              <a class="picto-baignoire dropdown-toggle" id="dropdownActions" (click)="toggleMenuChilds('equipement')"><span>Equipements / Actions</span></a>
              <div  aria-labelledby="dropdownActions" class="mb-3" [class.d-none]="!toggleMenuItems.equipement">
                <a (click)="toggleMenu()" routerLink="/mes-equipements" data-intro="equipements" class="ps-3 pt-2 pb-2">Mes équipements</a>
                <a (click)="toggleMenu()" routerLink="/actions" data-intro="actions" class="ps-3 pt-2 pb-2">Actions</a>
              </div>
            </li>
            @if ((logementCourant$ | async)?.currentUserIsOccupant) {
              <li  class="nav-item dropdown" >
                <a class="picto-rt2012 dropdown-toggle" id="dropdownConsommation" (click)="toggleMenuChilds('consommation')" ><span>Consommations</span></a>
                <div  aria-labelledby="dropdownConsommation" class="mb-3" [class.d-none]="!toggleMenuItems.consommation">
                  <a (click)="toggleMenu()" routerLink="/rt2012/suivi-des-consommations" data-intro="Consommations" class="ps-3 pt-2 pb-2">Suivi</a>
                  <a (click)="toggleMenu()" routerLink="/comparaison"  data-intro="Consommations" class="ps-3 pt-2 pb-2">Comparaison</a>
                </div>
              </li>
            }
            <li  class="nav-item dropdown">
              <a class="picto-article dropdown-toggle" id="dropdownActus" (click)="toggleMenuChilds('conseil')"><span>Actus et conseils</span></a>
              <div [class.d-none]="!toggleMenuItems.conseil" aria-labelledby="dropdownActus" class="mb-3">
                <a (click)="toggleMenu()" routerLink="/actualites" data-intro="actualites" class="ps-3 pt-2 pb-2">Actualités</a>
                <a (click)="toggleMenu()" routerLink="/conseils" class="ps-3 pt-2 pb-2">Conseils</a>
              </div>
            </li>
            <li class="nav-item"><a (click)="toggleMenu()" routerLink="/contacts" class="picto-compte"><span>Carnet d'adresses</span></a></li>
            @if (showAnnouncements((logementCourant$ | async))) {
              <li class="nav-item"><a (click)="toggleMenu()" routerLink="/annonces" class="picto-partenaire"><span>Annonces partenaire</span></a></li>
            }
          }
        }
        @if (!previsualisation) {
          <li class="nav-item">
            <a (click)="toggleMenu()" routerLink="/mon-compte" class="picto-compte" data-intro="compte"><span>Mon compte</span></a>
          </li>
        }
        <li class="nav-item">
          <a (click)="toggleMenu()" routerLink="/infos-generales" class="picto-aide"><span>Qui sommes-nous ?</span></a>
        </li>
        <li><a (click)="modalService.open(modalNousContacter, {size: 'lg'})" class="picto-enveloppe"><span>Nous contacter</span></a></li>
        @if (!previsualisation) {
          <li class="nav-item">
            <a (click)="toggleMenu()" href="/logout" (click)="logout()" class="picto-croix"><span>Se déconnecter</span></a>
          </li>
        }
      </ul>
    </nav>
  </div>
</div>

<ng-template #modalNousContacter>
  <div class="modal-header">
    <h4 class="modal-title">Nous contacter</h4>
    <p class="modal-sub-title">
      Ce formulaire permet de contacter l'équipe CLÉA et non le promoteur/ constructeur/ syndic de votre logement. Nous ne pourrons malheureusement pas vous aider pour des questions de réserves/ pannes/ dysfonctionnement de votre logement.
    </p>
  </div>
  <div class="modal-body">
    <app-nous-contacter></app-nous-contacter>
  </div>
</ng-template>
